export default "__VITE_ASSET__ZrJ$0IRn__"